import Grid from '@mui/material/Grid';

const ListingSectionItem = ({ children, params }) => {
  const { size, ...restParams } = params ?? {};
  return (
    <Grid display="flex" size={{ lg: 8, xs: 12, ...size }} {...restParams}>
      {children}
    </Grid>
  );
};

export default ListingSectionItem;
